var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callback-page"},[(!_vm.showModal)?_c('div',{staticClass:"callback-container"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callback-card"},[_c('div',{staticClass:"callback-header"},[_c('h2',[_vm._v("Processing...")])])])
}]

export { render, staticRenderFns }